import { http } from '@api/client';
import { paramterize, pickResponse, pickResult, cachedApi } from '@api/utils';
import { RegionCountryMaster } from '@lib/region-country-master';
import {
  RegionCountryFilterParams,
  // ServiceManagementSearchResult,
  RegionCountryResult,
  FilterResponse,
  SearchRegionCountryQuery,
  SearchRegionCountryResponse,
  ServicesAutoCompleteResult,
} from './types';
import { map } from 'rxjs/operators';
import { of } from 'rxjs';
/**
 * Get latest deals or search and get the fitered deals.
 * @param query The query params to pass to the url.
 */
export function search(query: SearchRegionCountryQuery, vtr_id: number) {
  const params = paramterize(query);
  return http
    .get<SearchRegionCountryResponse>(`/region-country-master/search/${vtr_id}`, {
      params,
    })
    .pipe(pickResponse());
}

/**
 * Get the deal details from the server.
 * @param id The id of the deal to get
 */
export function get(vtr_id: number) {
  return http.get<RegionCountryResult>(`/region-country-master/${vtr_id}`).pipe(pickResult());
}

// /**
//  * Filter deals using dynamic operators.
//  * @param option Query options
//  */
// export function filter(
//   company_region_vtr_id: string,
//   {
//     filters = [],
//     pageSize: page_size = 10,
//     page = 1,
//     sortBy = [],
//   }: RegionCountryFilterParams = {}
// ) {
//   const sort = sortBy.map(({ id, desc }) => `${desc ? '$desc' : '$asc'}|||${id}`).join(';');

//   const newFilters = filters; //updateFiltersForLinkedOperator(filters);
//   const filtersMap: Record<string, string> = newFilters.reduce(
//     (map, f) =>
//       Object.assign(map, {
//         [f.id]: Object.entries(f.value)
//           .map(([op, v]) => {
//             return op === '$bw'
//               ? `$gte|||${v[0]};$lte|||${v[1]}`
//               : op === '$in' && f.id === 'service_provided_id'
//               ? `$in|||${v
//                   .split(',')
//                   .map(v => v.split('|||')[0])
//                   .join(',')}`
//               : `${op}|||${v}`;
//           })
//           .join(';'),
//       }),
//     {}
//   );

//   const params = paramterize({ page_size, page, sort, ...filtersMap });

//   return http
//     .get<FilterResponse>(`/company-content-relation/search/${company_region_vtr_id}`, { params })
//     .pipe(pickResponse());
// }

/**
 * Filter deals using dynamic operators.
 * @param option Query options
 */
export function filter({
  filters = [],
  pageSize: page_size = 10,
  page = 1,
  sortBy = [],
}: RegionCountryFilterParams = {}) {
  // const isCompanySort = (key: string) => ['company_name'].includes(key);
  // const isContentSort = (key: string) => ['content_title'].includes(key);
  // const isClientSort = (key: string) => ['client_name'].includes(key);
  // const isServiceNameSort = (key: string) => ['company_service_name'].includes(key);

  // const sort_company_name = sortBy
  //   .filter(({ id }) => isCompanySort(id))
  //   .map(({ id, desc }) => `${desc ? '$desc' : '$asc'}|||${id}`)
  //   .join(';');

  // const sort_content_title = sortBy
  //   .filter(({ id }) => isContentSort(id))
  //   .map(({ id, desc }) => `${desc ? '$desc' : '$asc'}|||${id}`)
  //   .join(';');

  // const sort_client_name = sortBy
  //   .filter(({ id }) => isClientSort(id))
  //   .map(({ id, desc }) => `${desc ? '$desc' : '$asc'}|||${id}`)
  //   .join(';');

  // const sort_service_name = sortBy
  //   .filter(({ id }) => isServiceNameSort(id))
  //   .map(({ id, desc }) => `${desc ? '$desc' : '$asc'}|||${id}`)
  //   .join(';');

  const sort = sortBy
    // .filter(
    //   ({ id }) =>
    //     !isCompanySort(id) && !isContentSort(id) && !isClientSort(id) && !isServiceNameSort(id)
    // )
    .map(({ id, desc }) => `${desc ? '$desc' : '$asc'}|||${id}`)
    .join(';');

  /////

  const newFilters = filters; //updateFiltersForLinkedOperator(filters);
  const filtersMap: Record<string, string> = newFilters.reduce(
    (map, f) =>
      Object.assign(map, {
        [f.id]: Object.entries(f.value)
          .map(([op, v]) => {
            return op === '$bw'
              ? `$gte|||${v[0]};$lte|||${v[1]}`
              : op === '$in' && f.id === 'service_provided_id'
              ? `$in|||${v
                  .split(',')
                  .map(v => v.split('|||')[0])
                  .join(',')}`
              : `${op}|||${v.trim()}`;
          })
          .join(';'),
      }),
    {}
  );

  const params = paramterize({
    page_size,
    page,
    sort,
    // sort_company_name,
    // sort_content_title,
    // sort_client_name,
    // sort_service_name,
    ...filtersMap,
  });

  return http.get<FilterResponse>(`/region-country-master/search`, { params }).pipe(pickResponse());
  // return of([
  //     {
  //       vtr_id: 300,
  //       region: 'PTV1',
  //       region_aka: 'phillipnes taiwan vietnam',
  //       country_names: ['Taiwan', 'Phillipines', 'Vietnam', 'Indonesia'],
  //     },
  //     {
  //       vtr_id: 301,
  //       region: 'APAC',
  //       region_aka: 'phillipnes taiwan vietnam',
  //       country_names: ['Taiwan', 'Phillipines', 'Vietnam', 'Indonesia'],
  //     },
  //   ]);
}

/** Full catalog for Markets Responsible. One request is reused for the session. */
export const filterCatalog = cachedApi(() => filter({ pageSize: 500, page: 1 }));

// /**
//  * Merge deals.
//  * @param data The merge request model.
//  */
// export function merge(data: DealMergeRequest) {
//   return http.put<DealResult>('/deals/related', data).pipe(pickResponse());
// }

/**
 * Updates the given deal.
 * @param deal The deal to update
 */
export function update(regionData: Partial<RegionCountryMaster>) {
  return http
    .put<RegionCountryMaster>(`/region-country-master/${regionData.vtr_id}`, regionData)
    .pipe(pickResponse());
}

/**
 * Deletes the given deal.
 * @param deal The deal id or the actual deal.
 */
export function remove(regionData: Partial<RegionCountryMaster>) {
  return http
    .delete<RegionCountryMaster>(
      `/region-country-master/${regionData.vtr_id}`
      // , {
      //   data: { vtr_id: relationData.vtr_id,
      //     delete_reason: relationData.delete_reason },
      // }
    )
    .pipe(pickResponse());
}

/**
 * Creates the given deal.
 * @param deal The deal to create
 */
export function create(regionData: Partial<RegionCountryMaster>) {
  return http.post<RegionCountryResult>(`/region-country-master`, regionData).pipe(pickResponse());
}
